import { IWorkspace } from '../interfaces/workspace.interface';
import { IDashbackResponse } from '../interfaces/responses.interface';
import { API as API_BACKEND } from './config-backend.api';
import { API as API_DASHBACK } from './config-dashback.api';

export const getWorkspaces = () => API_DASHBACK.get('/delivery-partner/getSmallFleetByUser');

export const createWorkspace = (
    data: any,
): Promise<IDashbackResponse<IWorkspace>> => API_DASHBACK.post('/delivery-partner/createSmallFleet', data);

export const uploadWorkspaceLogo = (file: any) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', 'SMALL_FLEETS');

    return API_BACKEND.post('/user/uploadFile', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).catch((error: unknown) => {
        throw error;
    });
};

export const updateWorkspace = (id: string, data: any) => API_DASHBACK.put(`/delivery-partner/${id}`, data);
